import { useOrganizationGetMyOrganizations } from "@crowdcoursing/api/openapi";
import { useMemo } from "react";

import { type Organization } from "~ui/organisms/Organizations/types";

function mapToOrganization(org: {
  id?: string;
  bubbleId?: string;
  name?: string | null;
  address?: string | null;
  description?: string | null;
  type?: string | null;
  slug?: string | null;
}): Organization {
  const type = org.type ?? "";
  return {
    address: org.address ?? null,
    canCreateEvents: true,
    description: org.description ?? null,
    id: org.id ?? org.bubbleId ?? "",
    isExternal: type === "Organization",
    name: org.name ?? "",
    organizationType: org.type ?? null,
    slug: org.slug ?? undefined,
  };
}

export const useMyOrganizations = () => {
  const { data, isLoading, error } = useOrganizationGetMyOrganizations({});

  const organizations = useMemo(() => {
    if (!data) {
      return [];
    }
    return data.map(mapToOrganization);
  }, [data]);

  return {
    error,
    isLoading,
    organizations,
  };
};
